/** * * Asynchronously loads the component for
DataTopup
* */ import { lazyLoad } from "utils/loadable";
export const DataTopup = lazyLoad(
  () => import("./index"),
  (module) => module.DataTopup
);
